import Modal from "react-modal";
import Lottie from "react-lottie";
import animationLoader from "../lotties/animation_loader.json";
import animationLoaderMA from "../lotties/animation_loaderMA.json";
import animationLoaderZyia from "../lotties/animation_loaderZyia.json";
import animationLoaderYoli from "../lotties/animation_loaderYoli.json";
import animationLoaderDefault from "../lotties/animation_loaderDefault.json";
import useAppAccessor from "../../hooks/useappAccessor";

const customStyles = {
  content: {
    //   top: '50%',
    //   left: '50%',

    backgroundColor: "rgba(0,0,0,0.7)",

    overflow: "hidden",
    inset: 1,
    border: 0,
  },
  overlay: {
    backgroundColor: "rgba(0,0,0,0.7)",

    zIndex: 1020,
    top: 0,
    left: 0,
    width: "100vw",
    height: "100vh",
  },
};


const Loader = (props: any) => {
    const { getUserData } = useAppAccessor();
  const { client } = getUserData();
  function afterOpenModal() {
    // references are now sync'd and can be accessed.
  }

  function closeModal() {
    // setIsOpen(false);
    // props.handleCloseMediaInteraction()
  }


const checkBrand = (client: any) => {
    switch (client) {
      case "marketamerica": {
        return animationLoaderMA
      }
      case "zyiaactive": {
        return animationLoaderZyia
      }
      case "beyondslim": {
        return animationLoaderZyia
      }
      case "Yoli": {
        return animationLoaderYoli
      }
      case "Verb": {
        return animationLoaderDefault
      }
      case "Hussle": {
        return animationLoaderDefault
      }
      case "tranont": {
        return animationLoaderDefault
      }

      default:
        return ''
    }
  };

const defaultOptions = {
  loop: true,
  autoplay: true,
  animationData: checkBrand(client),
  rendererSettings: {
    preserveAspectRatio: "xMidYMid slice",
  },
};

  return (
    <Modal
      isOpen={props.isShowLoader}
      onAfterOpen={afterOpenModal}
      onRequestClose={closeModal}
      style={customStyles}
      contentLabel="Example Modal"
    >
      <div className=" flex w-full h-full  items-center justify-center  rounded ">
        <div className="flex-col">
          <Lottie options={defaultOptions} height={90} width={90} speed={3} />
          <span
            className="text-lg text-[#eeeeee] mt-2"
            style={{ opacity: 0.7 }}
          >
            {props.message}
          </span>
        </div>
      </div>
    </Modal>
  );
};

export default Loader;
